import { useEffect } from "react";
import { isUserInAWFlows } from "@tvg/login-controller/src/selectors/user-ts";
import { useSelector } from "react-redux";
import {
  addCookie,
  getCookieValue,
  removeCookie
} from "@tvg/sh-utils/sessionUtils";
import { breakpoints, useMediaQuery } from "@tvg/design-system";

const useEnableAWFlows = () => {
  const enableAWFlows = useSelector(isUserInAWFlows);
  const isDesktop = useMediaQuery(breakpoints.desktop.min.lg);

  useEffect(() => {
    if (typeof window !== "undefined" && isDesktop) {
      const useTvg5Val = getCookieValue("useTvg5", undefined);
      if (typeof useTvg5Val === "undefined") {
        if (enableAWFlows) {
          addCookie("useTvg5", "true");
          window.location.reload();
        } else {
          addCookie("useTvg5", "false");
        }
        return;
      }

      if (enableAWFlows && !useTvg5Val) {
        removeCookie("useTvg5");
        addCookie("useTvg5", "true");
        window.location.reload();
      }
    }
  }, [enableAWFlows]);
};

export default useEnableAWFlows;
